import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { resetCurrentNodeLevelStateAndAbove } from "../utils/resetCurrentNodeLevelStateAndAbove";
import { routeToStepPage, selfServePageToStepAndRoute, selfServePageToStepAndRouteWithoutOrderSelection, stepPageToNodeLevelAboveThatNeedsToBeCleaned } from "../view/step";
import { useNavigationStore } from "./NavigationContext";
import { useSelfServeContextStore } from "./SelfServeContext";
export var useNavigationInitializationEffect = function useNavigationInitializationEffect() {
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var _useNavigationStore = useNavigationStore(["currentPage"]),
    _useNavigationStore2 = _slicedToArray(_useNavigationStore, 2),
    currentPage = _useNavigationStore2[0].currentPage,
    setNavigationStore = _useNavigationStore2[1];
  var _useSelfServeContextS = useSelfServeContextStore(["brandOrders"]),
    _useSelfServeContextS2 = _slicedToArray(_useSelfServeContextS, 2),
    brandOrders = _useSelfServeContextS2[0].brandOrders,
    setSelfServeContextStore = _useSelfServeContextS2[1];
  useEffect(function () {
    var stepPage = routeToStepPage[pathname];
    var currentPageChanged = currentPage !== stepPage;
    if (currentPageChanged) {
      if (brandOrders && brandOrders.length > 0) {
        setNavigationStore({
          currentStep: selfServePageToStepAndRoute[stepPage].step,
          currentPage: stepPage
        });
        resetCurrentNodeLevelStateAndAbove({
          level: stepPageToNodeLevelAboveThatNeedsToBeCleaned[stepPage],
          setSelfServeContextStore: setSelfServeContextStore
        });
      } else {
        setNavigationStore({
          currentStep: selfServePageToStepAndRouteWithoutOrderSelection[stepPage].step,
          currentPage: stepPage
        });
        resetCurrentNodeLevelStateAndAbove({
          level: stepPageToNodeLevelAboveThatNeedsToBeCleaned[stepPage],
          setSelfServeContextStore: setSelfServeContextStore
        });
      }
    }
  }, [brandOrders, currentPage, pathname, setNavigationStore, setSelfServeContextStore]);
};